import { render, staticRenderFns } from "./arrow-image.vue?vue&type=template&id=374c37a8&scoped=true&"
import script from "./arrow-image.vue?vue&type=script&lang=js&"
export * from "./arrow-image.vue?vue&type=script&lang=js&"
import style0 from "./arrow-image.vue?vue&type=style&index=0&id=374c37a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "374c37a8",
  null
  
)

export default component.exports